<app-page-header
  [title]="i18n.t('storyboard3d.title')"
  [subtitle]="i18n.t('storyboard3d.subtitle')"
  [icons]="headerIcons">
</app-page-header>

<div class="storyboard3d-container">
  <!-- 左側: 3D表示エリア -->
  <div class="canvas-wrapper">
    <canvas #webglCanvas></canvas>
    <div class="loading-overlay" *ngIf="isObjLoading">
      <p>Loading... {{ progress }}%</p>
    </div>
    <div class="controls">
      <button class="spectrum-button spectrum-button--secondary" (click)="setCameraView('front')">{{ i18n.t('storyboard3d.viewFront') }}</button>
      <button class="spectrum-button spectrum-button--secondary" (click)="setCameraView('top')">{{ i18n.t('storyboard3d.viewTop') }}</button>
      <button class="spectrum-button spectrum-button--secondary" (click)="setCameraView('side')">{{ i18n.t('storyboard3d.viewSide') }}</button>
    </div>
  </div>

  <!-- 右側: コントロール＆画像表示 -->
  <div class="side-panel">
    <!-- ファイルアップロード & Adobe Stock リンク -->
    <div class="upload-section">
      <input type="file" (change)="onFileSelected($event)" accept=".obj,.glb,.gltf,.fbx" />
      <a href="https://stock.adobe.com/jp/3d-assets" target="_blank">{{ i18n.t('storyboard3d.stockLink') }}</a>
    </div>

    <!-- プロンプト入力エリア -->
    <textarea [placeholder]="i18n.t('storyboard3d.promptPlaceholder')" [(ngModel)]="prompt"></textarea>

    <!-- ボタン -->
    <div class="buttons">
      <button class="spectrum-button spectrum-button--primary" (click)="generateImage()">{{ i18n.t('storyboard3d.generateImage') }}</button>
      <!-- <button class="spectrum-button spectrum-button--secondary" (click)="resetView()">リセット</button> -->
    </div>

    <!-- 生成画像エリア -->
    <div class="generated-images">
      <div class="image-list">
        <div class="image-gallery image-gallery--loading" *ngIf="isCreating">
          <app-loading [message]="i18n.t('common.generatingImage')"></app-loading>
        </div>

        <div *ngFor="let image of generatedImages; let i = index" class="image-container">
          <canvas #drawCanvas 
            (mousedown)="onMouseDown(i, $event)" 
            (mousemove)="onMouseMove(i, $event)" 
            (mouseup)="onMouseUp(i)">
          </canvas>
        </div>
      </div>

      <ng-container *ngIf="generatedImages.length < 1 && !isCreating">
        <div class="no-images">
          <img src="/assets/img_creating_image.svg" alt="">
          <p>{{ i18n.t('storyboard3d.noImageHint') }}</p>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<app-toast></app-toast>